/**
 * DesignShelf — user_stories / personas. Wireframes and Mockups have no
 * page, so they are not shown (founder 6427360275 item 5).
 *
 * Phase 6 §"6-shelf reserve". Round 6 UX vocabulary discipline: top-
 * level label is the verb-as-noun ("Design"); sub-entities use
 * product names.
 */

import { ShelfCard } from "./ShelfCard";
import type { ShelfLabelResolver } from "./types";
import { IDENTITY_SHELF_LABEL } from "./types";

interface Props {
  projectId?: string | null;
  /** Template-layer vocabulary SKIN resolver (supplied by ShelfSidebar; one
   *  deduped fetch). Entity-type cards skin; Wireframes/Mockups (product
   *  artifacts, not canonical types) stay verbatim. Defaults to canonical. */
  label?: ShelfLabelResolver;
}

export function DesignShelf({ projectId, label = IDENTITY_SHELF_LABEL }: Props) {
  const base = projectId ? `/projects/${projectId}` : "";
  return (
    <div
      data-testid="design-shelf"
      role="region"
      aria-label="Design"
      className="grid grid-cols-1 gap-2 p-3 sm:grid-cols-2"
    >
      <ShelfCard
        to={`${base}/user-stories`}
        label={label("user_story", { plural: true, fallback: "User Stories" })}
        testId="design-user-stories"
      />
      <ShelfCard
        to={`${base}/personas`}
        label={label("user_persona", { plural: true, fallback: "Personas" })}
        testId="design-personas"
      />
    </div>
  );
}
